import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function mustHaveOneRecord(errorText: string = ''): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {

    const vector = control.value as any[];
    if (!vector) {
      return null;
    }

    if (vector.length <= 0) {
      return {
        description: errorText,
        code: '300',
      };
    }

    return null;
  };
}
